module.exports = __webpack_public_path__ + "media/mypage/images/top2-d254129dd7418c82c71218888a08e3c4.jpg";